export const transformStringToLowerCase = (value) => {
    if (typeof value !== 'string') {
        return '';
    }
    return value.toLowerCase();
};
